<template>
    <v-container>
        <v-container class="text-overline text-center">- Contact US -</v-container>

        <v-container class="text-center">
            <v-card outlined class="d-inline-block px-4" style="width: 300px;">
                <v-icon large class="mt-4">mdi-account-group</v-icon>
                <v-card-title class="justify-center">Support</v-card-title>
                <v-card-text class="text-left">
                    <div class="mb-3">
                        <v-icon small left>email</v-icon>contact.marketpett@gmail.com
                    </div>
                    <!-- <div>
                        <v-icon small left>mdi-phone</v-icon>085-335-5575
                    </div> -->
                </v-card-text>
            </v-card>

            <!-- <v-card outlined class="d-inline-block px-4 mt-6" style="width: 300px;">
                <v-icon large class="mt-4">mdi-account-hard-hat</v-icon>
                <v-card-title class="justify-center">Developer</v-card-title>
                <v-card-text class="text-left">
                    <div class="mb-3">
                        <v-icon small left>email</v-icon>chouwat.c@ku.th
                    </div>
                </v-card-text>
            </v-card> -->
        </v-container>
    </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>